<div [attr.data-testid]="testIds.orgUserList">
  <div class="header-row" [attr.data-testid]="testIds.orgHeader"></div>

  <div class="filter-row" [attr.data-testid]="testIds.filterRow">
    <span class="filter-label" [attr.data-testid]="testIds.filterLabel">Filter</span>
    <div class="filter-controls" [attr.data-testid]="testIds.filterControls">
      <mat-form-field appearance="outline" class="custom-filter-field" [attr.data-testid]="testIds.userFilterDropdown">
        <mat-select
          (selectionChange)="onFilterChange()"
          [attr.data-testid]="testIds.userFilterSelect"
          [(ngModel)]="selectedOption">
          @for (option of options; track $index) {
            <mat-option [value]="option.value" [attr.data-testid]="option.dataTestId">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="interaction-wrapper">
        <app-tonal-button
          buttonText="Systemmeldung senden"
          (clicked)="matDialog.open(sysNotification)"
          [dataTestId]="testIds.sysNotifyButton"></app-tonal-button>
        <app-table-settings
          [allColumns]="columns"
          [displayedColumns]="displayedColumns"
          [attr.data-testid]="testIds.tableSettingsComponent">
        </app-table-settings>
      </div>
    </div>
  </div>

  <app-generic-table
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    [dataSource]="(userResponse$ | async)!"
    [columnsToDisplay]="displayedColumns"
    [pageSize]="itemsPerPage"
    [pageIndex]="pageIndex"
    [totalItems]="total"
    [isLoading]="(loadingService.isLoading$ | async)!"
    [activeSortKey]="'displayname'"
    (rowClick)="navigateToUserSettings($event)"
    [attr.data-testid]="testIds.orgUserTable"></app-generic-table>
</div>

<ng-template #statusTemplate let-row>
  <div class="status-container">
    @if (row.deactivated) {
      <span class="status-item status-deleted"></span>
    } @else {
      <span class="status-item status-active"></span>
    }
    <p>{{ row.deactivated ? 'Gelöscht' : 'Aktiv' }}</p>
  </div>
</ng-template>

<ng-template #sysNotification>
  <div>
    <h2>Neue Meldung erzeugen</h2>
    <p>Erstellen Sie eine Meldung für den Nutzer</p>
    <form class="sys-form" [formGroup]="sysNotificationForm" (ngSubmit)="sendSysNotification()">
      <mat-form-field class="" [attr.data-testid]="testIds.userInputField">
        <input
          matInput
          [attr.data-testid]="testIds.userInput"
          [matAutocomplete]="auto"
          formControlName="user_id"
          placeholder="Alle"
          (input)="searchForSys($event.target!)" />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          [attr.data-testid]="testIds.usernameAutocompleteContainer">
          @for (user of filteroption$ | async; track user) {
            <mat-option [value]="user.name + ' ' + user.displayname" [attr.data-testid]="'button_' + user.name"
              >{{ user.displayname }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field [attr.data-testid]="testIds.messageInputField" formGroupName="content">
        <textarea
          matInput
          [attr.data-testid]="testIds.messageInput"
          formControlName="body"
          cdkAutosizeMaxRows="15"
          cdkAutosizeMinRows="5"
          cdkTextareaAutosize
          placeholder="Systemmeldung"></textarea>
      </mat-form-field>
      <div class="form-button-wrapper">
        <app-button [attr.data-testid]="testIds.cancelSysNotify" text="Abbrechen" (click)="resetForm()"></app-button>
        <app-button
          [attr.data-testid]="testIds.submitSysNotify"
          text="Senden"
          [isPrimary]="true"
          (keydown)="$event.stopPropagation()"
          [isDisabled]="!sysNotificationForm.valid"
          type="submit"></app-button>
      </div>
    </form>
  </div>
  @if (showSpinner) {
    <div [attr.data-testid]="testIds.spinnerBackdrop" class="spinner-backdrop">
      <app-sb-spinner class="verify-spinner" [type]="'spinnerIndeterminate'"></app-sb-spinner>
    </div>
  }
</ng-template>
